<script>
import SelectInput from "@/Jetstream/SelectInput";
import Template from '{Template}/Web/Pages/Wallet/Withdraw/Fiat/WithdrawFiatSuccess.template'
import AppLayout from '@/Layouts/AppLayout'
import JetButton from '@/Jetstream/Button'
import TextUserInput from "@/Jetstream/TextUserInput";
import NavButtonLink from "@/Jetstream/NavButtonLink";

export default Template({
    components: {
        AppLayout,
        SelectInput,
        JetButton,
        TextUserInput,
        NavButtonLink
    },
})
</script>
